module.exports = __webpack_public_path__ + "img/file-icon.5f9af4b3.svg";